import type { ReactNode } from 'react';
import s from '@/pages/console/console.module.css';

/**
 * A drop-down. The header line carries the status (title, one-line summary,
 * a count); the detail is inside and closed by default, so the top of every
 * page stays status plus actions.
 */
export function Section({ title, summary, count, defaultOpen = false, id, children }: {
  title: string;
  summary?: ReactNode;
  count?: number | string | null;
  defaultOpen?: boolean;
  id?: string;
  children: ReactNode;
}) {
  return (
    <details className={s.section} open={defaultOpen} id={id}>
      <summary>
        <span className={s.sectionTitle}>{title}</span>
        {summary !== undefined && summary !== null && <span className={s.sectionSummary}>{summary}</span>}
        {count !== undefined && count !== null && <span className={s.sectionCount}>{count}</span>}
      </summary>
      <div className={s.sectionBody}>{children}</div>
    </details>
  );
}
